/* ============================================================= *
 *  form.js  – validator & utility functions for React forms     *
 *  Tutte le funzioni sono PURE:                                 *
 *    • nessun accesso diretto al DOM                            *
 *    • restituiscono { isValid, errors }                        *
 *      – errors è un oggetto { campo : messaggio }              *
 * ============================================================= */

/* ----------  REGEX di supporto  ------------------------------ */
const NAME_RGX      = /^[a-zA-Z][a-zA-Z ]{1,32}$/;                    // 2-32 lettere
const SURNAME_RGX   = /^[a-zA-Z][a-zA-Z ]{1,32}$/;                    // 2-32 lettere
const EMAIL_RGX     = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_RGX  = /^(?=.*\d)(?=.*[\p{P}\p{S}])[\p{L}\p{N}\p{P}\p{S}]{8,64}$/u;
const PIN_RGX       = /^\d{4}$/;                                      // 4 cifre
const TWEET_RGX     = /^.{1,140}$/;                                   // 1-140 char
// gg/mm/aaaa  – anni 1900-2024
const BIRTHDATE_RGX = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(19\d{2}|20(0\d|1\d|2[0-4]))$/;

/* ----------  helpers  ---------------------------------------- */
const addError = (errors, field, message) => {
  errors[field] = message;
};

const buildResult = (errors) => ({
  isValid: Object.keys(errors).length === 0,
  errors,
});

/* ----------  VALIDATION FUNCTIONS  --------------------------- */

/** Registration: { name, surname, birthdate, email, password } */
function validateRegistration(values, setValues) {
  const errors = {};

  if (!NAME_RGX.test(values.name || "")) {
    addError(errors, "name", "Minimo 2 e massimo 32 lettere");
  }
  if (!SURNAME_RGX.test(values.surname || "")) {
    addError(errors, "surname", "Minimo 2 e massimo 32 lettere");
  }
  if (!BIRTHDATE_RGX.test(values.birthdate || "")) {
    addError(errors, "birthdate", "Formato gg/mm/aaaa");
  }
  if (BIRTHDATE_RGX.test(values.birthdate || "")) {
      const [dd, mm, yyyy] = values.birthdate.split("/").map(Number);
      const dateObj = new Date(yyyy, mm - 1, dd);
      const isRealDate =
        dateObj.getFullYear() === yyyy &&
        dateObj.getMonth() === mm - 1 &&
        dateObj.getDate() === dd;
      if (!isRealDate) {
        addError(errors, "birthdate", "Data non valida");
      } else {
        // salvo la versione ISO (yyyy-mm-dd) per l’invio al server
        values.birthdate_iso = `${yyyy}-${String(mm).padStart(2,"0")}-${String(dd).padStart(2,"0")}`;
      }
    }
  if (!EMAIL_RGX.test(values.email || "")) {
    addError(errors, "email", "Email non valida");
  }
  if (!PASSWORD_RGX.test(values.password || "")) {
    addError(
      errors,
      "password",
      "La password deve essere lunga dagli 8 ai 32 caratteri, tra lettere, numeri e almeno un carattere speciale/punteggiatura",
    );
  }
  return buildResult(errors);
}

/** Login: { email, password } */
function validateLogin(values) {
  const errors = {};
  if (!(values.email || "").trim()) addError(errors, "email", "Compila questo campo");
  if (!(values.password || "").trim()) addError(errors, "password", "Compila questo campo");
  return buildResult(errors);
}

/** Email only: { email } */
function validateEmail(values) {
  const errors = {};
  if (!(values.email || "").trim()) addError(errors, "email", "Compila questo campo");
  return buildResult(errors);
}

/** PIN: { pin } */
function validatePin(values) {
  const errors = {};
  if (!PIN_RGX.test(values.pin || "")) addError(errors, "pin", "Codice non valido");
  return buildResult(errors);
}

/** Tweet/post: { textTweet } */
function validateTweet(values) {
  const errors = {};
  if (!TWEET_RGX.test(values.textTweet || "")) addError(errors, "textTweet", "Questo campo non può essere vuoto");
  return buildResult(errors);
}
 
/* ----------  utility per il contatore tweet  ------------------ */
/**
 * Ritorna { length, overLimit, nearLimit }
 *   • overLimit:  > 140
 *   • nearLimit:  > 100  (per cambiare colore, ecc.)
 */
function getTweetLengthInfo(text = "") {
  const length = text.length;
  return {
    length,
    overLimit: length > 140,
    nearLimit: length > 100,
  };
}
